<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-button type="primary" icon="el-icon-lx-add" class="handle-add" @click="handleUserEdit(true, null)">新增用户</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="username" label="帐号" align="center"></el-table-column>
                <el-table-column prop="role.name" label="当前角色" align="center">

                </el-table-column>
                <el-table-column prop="nickname" label="昵称" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="handleAddRole(scope.row)"
                        >分配角色</el-button>
                      <el-button
                            type="text"
                            @click="handleAddPharmacy(scope.row)"
                        >关联药房</el-button>
                        <el-button
                            type="text"
                            @click="handleUserEdit(false, scope.row)"
                        >修改</el-button>
                        <el-button
                            type="text"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :page-count="totalPages"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <el-dialog :visible.sync="userEditVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="userForm" :model="user_form" :rules="user_rules" label-width="120px">
                <el-form-item label="帐号：" prop="username">
                    <el-input v-model="user_form.username" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="昵称：" prop="nickname">
                    <el-input v-model="user_form.nickname" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="密码：" prop="password">
                    <el-input v-model="user_form.password" @input="onInput()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveUserEdit('userForm')">提 交</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="roleVisible" width="60%" :close-on-click-modal="false">
            <el-form>
                <el-form-item label="选择角色：" prop="select_role_id">
                    <el-select v-model="select_role_id" class="handle-select">
                        <el-option
                        v-for="(child, index) in roles"
                        :key="index"
                        :label="child.name" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="handleConfirmRole">提 交</el-button>
            </span>
        </el-dialog>
      <el-dialog :visible.sync="PharmacyVisible" width="60%" :close-on-click-modal="false">
            <el-form>
                <el-form-item label="选择药房：" prop="select_role_id">
                    <el-select v-model="select_Pharmacy_id" class="handle-select">
                        <el-option
                        v-for="(item, i) in dorisData"
                        :key="i"
                        :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="handleConfirmPharmacy">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//import {_} from 'vue-underscore';
import http from '../../../api/manageApiConfig'
import http2 from '../../../api/dorisApiConfig'
//import http2 from '../../../api/iapetusApiConfig'
//import http3 from '../../../api/hermerApiConfig'
export default {
    name: 'Rolemanage',
    data() {
        return {
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            page_index: 0,
            loading: false,
            is_add: false,
            userEditVisible: false,
            user_form: {},
            user_rules: {
                username: [{ required: true, message: "请填写帐号", trigger: "blur" }],
                nickname: [{ required: true, message: "请填写昵称", trigger: "blur" }],
                password: [{ required: true, message: "请填写密码", trigger: "blur" }]
            },
            select_user_id: '',
            select_role_id: '',
          select_Pharmacy_id: '',
          yf_user_id: '',
          dorisData:[],
            roles: [],
            roleVisible: false,
          PharmacyVisible: false,
        };
    },
    created() {
        let that = this;
        that.getData();
        let params = {
            page: 1,
            page_size: 20
        }

      let token = localStorage.getItem('ms_token')
        http.get("admin/roles", {params: params}).then(function(res) {
            that.roles = res.data.data.roles;
        });
      http2.get("admin/select_providers", {headers: {"Authorization":token}}).then(function(res) {
            console.log(res)
        that.dorisData = res.data.data
        });
        http.get("admin/menus").then(function(res) {
            that.menus = res.data;
        });
    },
    methods: {
        onInput(){
            this.$forceUpdate();
        },
        getData() {
            let that = this;
            that.loading = true;
            let params = {
                page: that.currentPage,
                page_size: that.page_size
            }
            http.get("admin/users", {params: params}).then(function(res) {
                that.tableData = res.data.data.users;
                that.totalPages = res.data.data.total_pages;
                that.loading = false;
            });
        },
        handleDelete(row) {
            let that = this;
            // 二次确认删除
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                let params = {
                    user_id: row.id
                }
                http.delete("admin/users", {params: params}).then(function(res) {
                    if (res.data.status_code == 200) {
                        that.$message.success('删除成功');
                        that.getData();
                    }
                });
            })
            .catch(() => {});
        },
        handlePageChange(val) {
            this.currentPage = val;
            this.getData();
        },
        handleUserEdit(add, row){
            this.is_add = add;
            if(add){
                this.user_form = {
                    username: '',
                    nickname: '',
                    password: ''
                }
            }else{
                this.user_form = {
                    user_id: row.id,
                    username: row.username,
                    nickname: row.nickname,
                    password: row.password
                }
            }
            this.userEditVisible = true;
        },
        saveUserEdit(formName){
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        username: that.user_form.username,
                        nickname: that.user_form.nickname,
                        password: that.user_form.password
                    }
                    if(that.is_add){
                        http.post("admin/user", params).then(function(res) {
                            if (res.data.status_code == 200) {
                                that.$message.success(`新增成功`);
                                that.getData();
                            }
                        });
                    }else{
                        params['user_id'] = that.user_form.user_id;
                        http.put("admin/user", params).then(function(res) {
                            if (res.data.status_code == 200) {
                                that.$message.success(`修改成功`);
                                that.getData();
                            }
                        });
                    }
                    that.userEditVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleAddRole(row){
          console.log(row)
            this.select_user_id = row.id;
            this.select_role_id = row.role?row.role.id:'';
            this.roleVisible = true;
        },
        handleAddPharmacy(row){
          this.yf_user_id = row.id
          this.select_Pharmacy_id = row.providers_id;
          this.PharmacyVisible = true;
        },
      handleConfirmPharmacy(){
          let data = {
            user_id:this.yf_user_id,
            provider_id:this.select_Pharmacy_id,
          }
        http.put('admin/set_provider',data).then(res=>{
          if (res.data.status_code == 200) {
            this.$message.success(`分配成功`);
            this.getData();
            this.PharmacyVisible = false;
          }
        })
      },
        handleConfirmRole() {
            let that = this;
            let params = {
                user_id: that.select_user_id,
                role_id: that.select_role_id
            }
            http.post("/admin/role_user", params).then(function(res) {
                if (res.data.status_code == 200) {
                    that.$message.success(`分配成功`);
                    that.getData();
                    that.roleVisible = false;
                }
            });
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.self-dialog-footer{
    display: block;
    text-align: center;
}
</style>
